import React, {Component} from 'react';
import "../../ImpedanceCalculator/ImpedenceCustomization/CustomizationPage.css";
import {Link} from "react-router-dom";

class ViewStackUp extends Component {

    render() {
        return (

            <div className="impedance-stack-div ">
                <div className="row">
                    <div className="col-md-2"><b>Type 1 :</b></div>
                    <div className="col-md-8 pull-left">Recommended trace width: 3 - 100 mil !</div>
                </div>
                <div className="row">
                    <div className="col-md-8 col-md-offset-2">Order selection:JLC7628
                        <Link to="/stackUp">&nbsp;&nbsp; View stackup</Link>
                    </div>
                </div>
                <div className="spacer"></div>
                <div className="row">
                    <div className="col-md-2"><b>Type 2 :</b></div>
                    <div className="col-md-8">Recommended trace width: 3 - 100 mil !</div>
                </div>
                <div className="row">
                    <div className="col-md-8 col-md-offset-2">Order selection:JLC2313 View
                        <Link to="/stackUp">&nbsp;&nbsp; View stackup</Link>
                    </div>
                </div>

            </div>

        );
    }

}
export  default ViewStackUp;


// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/ImpedanceCalculator/ImpedencePreview/ViewStackUp.js